export default "__VITE_ASSET__253cfa4c__"